import { render, staticRenderFns } from "./AddAddress.vue?vue&type=template&id=f5bdb4f2&scoped=true"
import script from "./AddAddress.vue?vue&type=script&lang=js"
export * from "./AddAddress.vue?vue&type=script&lang=js"
import style0 from "./AddAddress.vue?vue&type=style&index=0&id=f5bdb4f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bdb4f2",
  null
  
)

export default component.exports